/* eslint max-len: 0 */
import React from 'react';

import pure from 'recompose/pure';

import SvgIcon from '@material-ui/core/SvgIcon';


let ClipboardIcon = props =>
  <SvgIcon {...props}>
    <path d="M7,8V6H5V19H19V6H17V8H7M9,4A3,3 0 0,1 12,1A3,3 0 0,1 15,4H19A2,2 0 0,1 21,6V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V6A2,2 0 0,1 5,4H9M12,3A1,1 0 0,0 11,4A1,1 0 0,0 12,5A1,1 0 0,0 13,4A1,1 0 0,0 12,3Z" />
  </SvgIcon>;

ClipboardIcon = pure(ClipboardIcon);
ClipboardIcon.muiName = 'SvgIcon';

export default ClipboardIcon;
